export const prospectForm = [
  {
    type: "text",
    label: "Company name",
    name: "companyName",
    required: true,
  },
  {
    type: "text",
    label: "Company phone number",
    name: "phoneNumber",
    required: true,
  },
  {
    type: "email",
    label: "Company e-mail",
    name: "email",
    required: true,
  },
  {
    type: "text",
    label: "Website",
    name: "website",
  },
  {
    type: "text",
    label: "Code VAT",
    name: "VATCode",
  },
  {
    type: "number",
    label: "SIRET number",
    name: "siret",
  },
  {
    type: "select",
    label: "M2 in store",
    name: "storeArea",
    options: [
      {
        name: "Less than 50 m2",
        code: "Less than 50 m2",
      },
      {
        name: "50-100 m2",
        code: "50-100 m2",
      },
      {
        name: "100-150 m2",
        code: "100-150 m2",
      },
      {
        name: "150–250 m2",
        code: "150–250 m2",
      },
      {
        name: "250-350 m2",
        code: "250-350 m2",
      },
      {
        name: "More than 350 m2",
        code: "More than 350 m2",
      },
    ],
  },
  {
    type: "multiSelect",
    label: "Company activities",
    placeholder: "Select",
    name: "activities",
    appendToSelf: true,
  },
  {
    type: "number",
    label: "Number of spa in store",
    name: "spaCount",
  },
  {
    type: "number",
    label: "Number of swim spa in store",
    name: "swimSpaCount",
  },
  {
    type: "select",
    label: "Pool/Spa Group",
    placeholder: "Select",
    name: "poolSpaGroup",
    options: [
      { name: "Dejoyaux", code: "Dejoyaux" },
      { name: "Piscine Ibiza", code: "Piscine Ibiza" },
      { name: "Piscine de France", code: "Piscine de France" },
      { name: "Aboral Piscine", code: "Aboral Piscine" },
      { name: "Alliance Piscines", code: "Alliance Piscines" },
      { name: "Aquilius Piscines", code: "Aquilius Piscines" },
      { name: "Bel'O Piscine", code: "Bel'O Piscine" },
      { name: "Blue Lagoon Spas", code: "Blue Lagoon Spas" },
      { name: "Caron Piscines", code: "Caron Piscines" },
      { name: "Cocktail Piscine", code: "Cocktail Piscine" },
      { name: "EuroPiscine", code: "EuroPiscine" },
      { name: "Irripiscine", code: "Irripiscine" },
      { name: "Hydrosud", code: "Hydrosud" },
      { name: "L'eau bien être", code: "L'eau bien être" },
      { name: "L'esprit Piscine", code: "L'esprit Piscine" },
      { name: "Fusion Piscine", code: "Fusion Piscine" },
      { name: "Mondial Piscine", code: "Mondial Piscine" },
      { name: "Neptune Piscines", code: "Neptune Piscines" },
      { name: "Oasis Piscines", code: "Oasis Piscines" },
      { name: "Carré Bleu", code: "Carré Bleu" },
      { name: "Magiline", code: "Magiline" },
      { name: "Solid Pool", code: "Solid Pool" },
    ],
    filter: true,
  },
  {
    type: "multiSelect",
    label: "Sold spa brand",
    placeholder: "Select",
    name: "spaMarques",
    appendToSelf: true,
  },
  {
    type: "select",
    label: "Account Manager",
    placeholder: "Select",
    name: "business_affiliate",
    appendToSelf: true,
  },
  {
    type: "select",
    label: "Busy Street / Commercial Zone",
    placeholder: "Select",
    name: "traffic",
    options: [
      {
        name: "Low",
        code: "low",
      },
      {
        name: "Medium",
        code: "medium",
      },
      {
        name: "High",
        code: "high",
      },
    ],
  },
  {
    type: "number",
    label: "Note on the internet",
    name: "internetNote",
    max: 5,
  },
  {
    type: "number",
    label: "Nber Fair & Show/year",
    name: "annualFairCount",
  },
  {
    type: "select",
    label: "Digital Ads",
    placeholder: "Select",
    name: "digitalAds",
    options: [
      {
        name: "Low",
        code: "low",
      },
      {
        name: "Medium",
        code: "medium",
      },
      {
        name: "High",
        code: "high",
      },
    ],
  },
  {
    type: "number",
    label: "Potentiel Spa/year",
    name: "annualSpaPotential",
  },
  {
    type: "select",
    label: "Prospect Provenance",
    name: "source",
    options: [
      {
        name: "Poseidon Spa Prospect",
        code: "Poseidon Spa Prospect",
      },
      {
        name: "Poseidon Spa Lead",
        code: "Poseidon Spa Lead",
      },
      {
        name: "Salon Pro ",
        code: "Salon Pro ",
      },
      {
        name: "Search",
        code: "Search",
      },
      {
        name: "Contact",
        code: "Contact",
      },
    ],
  },
];

export const noteForm = [
  {
    type: "number",
    label: "Note",
    name: "globalNote",
    offset: 6,
    max: 20,
    disabled: true,
  },
  {
    type: "number",
    label: "Store note: zone and dimension",
    name: "storeNote",
    max: 5,
  },
  {
    type: "number",
    label: "Communication note: digital, network, radio, billboard",
    name: "communicationNote",
    max: 5,
  },
  {
    type: "number",
    label: "Event note: trade show, fair, and other events",
    name: "eventNote",
    max: 5,
  },
  {
    type: "number",
    label: "Service note: customer feedback, technical service",
    name: "serviceNote",
    max: 5,
  },
  {
    type: "textarea",
    label: "Comment",
    name: "comment",
  },
];

export const deliveryAddressForm = [
  {
    type: "text",
    label: "Adresse de livraison",
    name: "street",
    required: true,
  },
  {
    type: "text",
    label: "Code postal",
    name: "zip",
    required: true,
  },
  {
    type: "select",
    label: "Pays",
    placeholder: "Sélectionner",
    name: "country",
    required: true,
  },
  {
    type: "select",
    label: "Ville",
    placeholder: "Sélectionner",
    name: "city",
    subOption: "country",
    optionsName: "cities",
    required: true,
  },
];

export const billingAddressForm = [
  {
    type: "text",
    label: "Adresse de facturation",
    name: "street",
    required: true,
  },
  {
    type: "text",
    label: "Code postal",
    name: "zip",
    required: true,
  },
  {
    type: "select",
    label: "Pays",
    placeholder: "Sélectionner",
    name: "country",
    required: true,
  },
  {
    type: "select",
    label: "Ville",
    placeholder: "Sélectionner",
    name: "city",
    subOption: "country",
    optionsName: "cities",
    required: true,
  },
];

export const interlocutorForm = [
  {
    type: "text",
    label: "First name",
    name: "firstName",
    required: true,
  },
  {
    type: "text",
    label: "Last name",
    name: "lastName",
    required: true,
  },
  {
    type: "email",
    label: "Email",
    name: "email",
    required: true,
  },
  {
    type: "text",
    label: "phone number",
    name: "phoneNumber",
    required: true,
  },
  {
    type: "text",
    label: "Position",
    name: "occupation",
    required: true,
  },
  {
    type: "select",
    label: "Influence Decision",
    placeholder: "Select",
    name: "influenceDecision",
    options: [
      {
        name: "Low",
        code: "low",
      },
      {
        name: "Medium",
        code: "medium",
      },
      {
        name: "High",
        code: "high",
      },
    ],
  },
  {
    type: "select",
    label: "Spa Knowledge",
    placeholder: "Select",
    name: "spaKnowledge",
    options: [
      {
        name: "Low",
        code: "low",
      },
      {
        name: "Medium",
        code: "medium",
      },
      {
        name: "High",
        code: "high",
      },
    ],
  },
];

export const actionsForm = [
  {
    type: "select",
    label: "Action",
    placeholder: "Action",
    name: "type",
    required: true,
  },
  {
    type: "text",
    label: "Description",
    placeholder: "Description",
    name: "description",
    maxLength: 35,
  },
  {
    type: "select",
    label: "Interlocutor",
    placeholder: "Interlocutor",
    name: "interlocutor",
  },
  {
    type: "date",
    name: "date",
  },
  {
    type: "textarea",
    label: "Comment",
    placeholder: "Comment",
    name: "comment",
    rows: 4,
  },
];
